interface DrillCoverageHintProps {
  unknownCount: number;
}

export function DrillCoverageHint({ unknownCount }: DrillCoverageHintProps) {
  if (unknownCount === 0) return null;

  return (
    <span className="inline-flex items-center rounded-full bg-amber-100 px-2 py-0.5 text-xs font-medium text-amber-800 dark:bg-amber-900/30 dark:text-amber-300">
      {unknownCount} unfamiliar {unknownCount === 1 ? "lemma" : "lemmas"}
    </span>
  );
}
